import { Injectable, Inject } from '@angular/core';
import * as _ from 'lodash';
import { environment } from '../../../environments/environment';

@Injectable()
export class Common {

    public environment: any;

    constructor() {
      this.environment = environment;
    }

    DEFAULT_ERROR = 'En estos momentos no lo podemos antender. Por favor intente mas tarde';

    responseInterpreter(res) {
        console.log('******** ResponseInterpreter Input', res);
        res = res['response'];
        const response = res;
        if (_.get(res, 'status.code', '') === 200 || _.get(res, 'status.code', '') === 202) {
                response['middleware'] = _.get(res, 'middleware', null);
        } else {
            throw Error(this.DEFAULT_ERROR);
        }
        console.log('******** ResponseInterpreter Return', response);
        return response;
    }

    responseOperationStateInterpreter(res) {
        console.log('******** responseOperationStateInterpreter Input', res);
        res = res['response'];
        const response = res;
        if ((_.get(res, 'status.code', '') === 200 && _.get(res, 'middleware.operationState.code') === '00') ||
            (_.get(res, 'status.code', '') === 202 && _.get(res, 'middleware.operationState.code') === '00')) {
                response['middleware'] = _.get(res, 'middleware.operationState', null);
        } else {
            throw Error(this.DEFAULT_ERROR);
        }
        console.log('******** responseOperationStateInterpreter Return', response);
        return response;
    }

    cmmResponseInterpreter(res) {
        if (res['Detail'] && res['Detail']['errors']) {
            throw Error(this.DEFAULT_ERROR);
        }
        return res;
    }

    handleErrorsDefault(err) {
        console.log('******** HandleErrorsDefault Input', err);
        if (!this.environment.production) {
            console.log(err);
        }
        return { statusCode: err, message: this.DEFAULT_ERROR };
    }
}
